<template>
  <section :class="$style.view">
    <p :class="[$style.view__text, $style.text]">
      ご利用に当たっては有効なクレジットカードの登録が必要です。<br />
      クレジットカードを登録してください。<br />
      （決済サービスのStripeのページに移動します。）<br />
      <br />
      クレジットカードを登録済みの方でこの表示が出ている場合は、<br />
      お手数ですが画面を再読み込みしてください。
    </p>
    <FlatAnchorLinkButton
      size="medium"
      variant="plain"
      :class="[$style.view__button, $style.button]"
      :href="stripeUrl"
    >
      クレジットカードを登録する
    </FlatAnchorLinkButton>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useGenerateStripeCreditCardSavingUrl } from '@/features/contract/useContract/useContract'
import { useRouter } from 'vue-router'
import { useAlert } from '@/libs/alertPortal'
import { captureException } from '@sentry/vue'
import FlatAnchorLinkButton from '@/components/atoms/FlatAnchorLinkButton.vue'

const router = useRouter()

const { generateStripeCreditCardSavingUrl } =
  useGenerateStripeCreditCardSavingUrl(
    `${window.origin}${
      router.resolve({
        name: 'dashboard',
      }).href
    }`,
    `${window.origin}${
      router.resolve({
        name: 'dashboard',
      }).href
    }`
  )

const alert = useAlert()

const stripeUrl = ref<string>('')

const callGenerateStripeUrl = async () => {
  try {
    stripeUrl.value = await generateStripeCreditCardSavingUrl()
  } catch (error) {
    alert.error(
      'エラーが発生しました。時間をおいて画面を読み込み直してください。'
    )

    captureException(error)
  }
}

void callGenerateStripeUrl()
</script>

<style lang="scss" module>
.view {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;

  &__button {
    margin-top: 24px;
  }
}

.text {
  text-align: center;
}

.button {
  &__text {
    &:hover {
      text-decoration: none;
    }
  }
}
</style>
